import { render, staticRenderFns } from "./RisparmioReport.vue?vue&type=template&id=0fd96815&"
import script from "./RisparmioReport.vue?vue&type=script&lang=js&"
export * from "./RisparmioReport.vue?vue&type=script&lang=js&"
import style0 from "./RisparmioReport.vue?vue&type=style&index=0&id=0fd96815&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QBtn,QSeparator,QBanner,QTable});
